import {ALERT_TYPES} from '../../infra/utils/alerts'

const alertsArray = [
  {
    type: ALERT_TYPES.SMALL_PRIMARY,
    message: 'Remember: Primary alerts convey important information.',
    heading: 'Remember'
  },
  {
    type: ALERT_TYPES.SMALL_SECONDARY,
    message: 'Hey there! Secondary alerts provide additional context.',
    heading: 'Hey there!'
  },
  {
    type: ALERT_TYPES.SMALL_SUCCESS,
    message:
      'Great job! Success alerts indicate successful actions or outcomes.',
    heading: 'Great job!'
  },
  {
    type: ALERT_TYPES.SMALL_ERROR,
    message: 'Caution! Danger alerts warn about potential risks or errors.',
    heading: 'Caution!'
  },
  {
    type: ALERT_TYPES.SMALL_WARNING,
    message: 'Heads up! Warning alerts highlight important notices.',
    heading: 'Well done !'
  },
  {
    type: ALERT_TYPES.SMALL_INFO,
    message: 'Did you know? Info alerts offer interesting or helpful facts.',
    heading: 'Well done !'
  },
  {
    type: ALERT_TYPES.SUCCESS,
    footer:
      'Whenever you need to, be sure to use margin utilities to keep things nice and tidy.',
    heading: 'Yey ! Everything worked!',
    message: "This alert needs your attention, but it's not super important."
  },
  {
    type: ALERT_TYPES.ERROR,
    footer:
      'Whenever you need to, be sure to use margin utilities to keep things nice and tidy.',
    heading: 'Something is very wrong!',
    message: 'Change a few things up and try submitting again.'
  },
  {
    type: ALERT_TYPES.WARNING,
    footer:
      'Whenever you need to, be sure to use margin utilities to keep things nice and tidy.',
    heading: 'Well done !',
    message: "Better check yourself, you're not looking too good."
  },
  {
    type: ALERT_TYPES.INFO,
    footer:
      'Whenever you need to, be sure to use margin utilities to keep things nice and tidy.',
    heading: 'Well done !',
    message: 'Aww yeah, you successfully read this important alert message.'
  }
]

export default alertsArray
